var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, PeekStack, } from "@piiqtechnologies/ui-components";
import { useAnalytics, useError, useLoader, useNotification, useSpaceToken } from "@piiqtechnologies/ui-lib";
import { copyToClipboard, getSpaceEmbedCode, getSpaceUrl } from "@utils";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { getSpaceEmbedCodeFormFields, SpaceEmbedCodeFormInitialValues } from "./SpaceEmbedCodeFormConfig";
export const SpaceEmbedCodeDialog = ({ spaceId, open, onClose }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const [generateListingToken, token, listingTokenInProgress, listingTokenError] = useSpaceToken();
    useEffect(() => {
        setLoader(listingTokenInProgress);
        return () => setLoader(false);
    }, [listingTokenInProgress]);
    useEffect(() => {
        if (listingTokenError) {
            setError(listingTokenError === null || listingTokenError === void 0 ? void 0 : listingTokenError.message);
        }
    }, [listingTokenError]);
    const getListingToken = () => __awaiter(void 0, void 0, void 0, function* () {
        const listingToken = yield generateListingToken({ spaceId });
        return listingToken;
    });
    const onPreviewEmbedCode = (_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { dimensions, layoutSize } = _a, values = __rest(_a, ["dimensions", "layoutSize"]);
        const listingToken = yield getListingToken();
        const spaceUrl = getSpaceUrl(Object.assign({ token: listingToken }, values));
        window.open(spaceUrl);
    });
    const onCopyEmbedCode = (_a) => __awaiter(void 0, void 0, void 0, function* () {
        var { dimensions, layoutSize } = _a, values = __rest(_a, ["dimensions", "layoutSize"]);
        const listingToken = yield getListingToken();
        const embedLink = getSpaceEmbedCode(Object.assign(Object.assign({ token: listingToken }, dimensions), values));
        yield copyToClipboard(embedLink);
        analytics.track("Embed Virtual Tour Code");
        setNotification(intl.formatMessage(messages.spaceEmbedCodeCopySuccess));
        onClose();
    });
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.spaceEmbedCodeTitle), open: open, onClose: onClose },
        React.createElement(Formik, { initialValues: SpaceEmbedCodeFormInitialValues, onSubmit: () => {
                console.log("empty handler");
            } }, ({ values }) => (React.createElement(Form, null,
            React.createElement(PeekDialogContent, null,
                React.createElement(MultiColumnFormFields, { alignItems: "center", fields: getSpaceEmbedCodeFormFields() })),
            React.createElement(PeekDialogActions, null,
                React.createElement(PeekStack, { spacing: 1, width: "100%" },
                    React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "outlined", onClick: () => onPreviewEmbedCode(values) }, intl.formatMessage(messages.spaceEmbedCodePreviewButton)),
                    React.createElement(PeekButton, { fullWidth: true, size: "large", color: "primary", variant: "contained", onClick: () => onCopyEmbedCode(values) }, intl.formatMessage(messages.spaceEmbedCodeCopyButton)))))))));
};
export default SpaceEmbedCodeDialog;
